import Vue from 'vue'
import Router from 'vue-router'

// const Index = () => import ('@/pages/index')
import Index from '@/pages/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js